import homeImage from '../../assets/homeImage.jpeg';
import styles from './Home.module.scss';

function Main() {
  return <img src={homeImage} alt="Home" className={styles.homeImage} />;
}

export default Main;
